<section class="pt-16 px-container">
    <h1 class="text-3xl md:text-5xl lg:text-6xl">Amministrazione Trasparente</h1>
</section>

<section class="py-16 mb-8 px-container">
    <h4 class="font-mono lg:text-2xl text-xl mb-6">Testo coordinato del decreto - Legge 8 agosto 2013, n. 91</h4>
    <p class="mb-16 text-justify">
        Testo del decreto-legge 8 agosto 2013, n. 91 (in Gazzetta Ufficiale – serie generale – n. 186 del 9 agosto
        2013), coordinato con la legge di conversione 7 ottobre 2013, n. 112 (in questa stessa Gazzetta Ufficiale
        alla pag. 1), recante: «Disposizioni urgenti per la tutela, la valorizzazione e il rilancio dei beni e delle
        attività culturali e del turismo.». (13A08109) (GU n.236 del 8-10-2013) Vigente al: 8-10-2013 Art. 9
        Disposizioni urgenti per assicurare la trasparenza, la semplificazione e l’efficacia del sistema di
        contribuzione pubblica allo spettacolo dal vivo e al cinema.
        <br /><br />
        2. Gli enti e gli organismi dello spettacolo, finanziati a valere sul Fondo unico dello spettacolo di cui
        alla legge 30 aprile 1985, n. 163, o ai sensi della legge 23 dicembre 1996, n. 662, e successive
        modificazioni, pubblicano e aggiornano le seguenti informazioni relative ai titolari di incarichi
        amministrativi ed artistici di vertice e di incarichi dirigenziali, a qualsiasi titolo conferiti, nonché di
        collaborazione o consulenza: a) gli estremi dell’atto di conferimento dell’incarico; b) il curriculum vitae;
        c) i compensi, comunque denominati, relativi al rapporto dilavoro, di consulenza o di collaborazione.
        <br /><br />
        3. Le informazioni di cui al comma 2 sono pubblicate dagli enti ed organismi entro il 31 gennaio di ogni
        anno e comunque aggiornate anche successivamente. Ai predetti soggetti non possono essere erogate a
        qualsiasi titolo somme sino alla comunicazione dell’avvenuto adempimento o aggiornamento.
    </p>

    <div class="flex lg:flex-row flex-col gap-8">
        <div class="lg:w-1/2 w-full">
            <h4 class="font-mono lg:text-2xl text-xl">Organi Amministrativi in carica</h4>
            <ng-container *ngFor="let file of files | categoriaAmministrazioneTrasparente: 'organi_amministrativi'">                
                <a [href]="file.pdf | pdf" target="_blank" class="py-4 px-12 w-fit btn btn-sm btn-outln mt-4 block">{{file.titolo}}</a>
            </ng-container>
            <h4 class="font-mono lg:text-2xl text-xl mt-12">Organo Direttivo</h4>
            <ng-container *ngFor="let file of files | categoriaAmministrazioneTrasparente: 'organo_direttivo'">                
                <a [href]="file.pdf | pdf" target="_blank" class="py-4 px-12 w-fit btn btn-sm btn-outln mt-4 block">{{file.titolo}}</a>
            </ng-container>
        </div>

        <div class="lg:w-1/2 w-full">
            <h4 class="font-mono lg:text-2xl text-xl">Consulenze e Collaborazioni</h4>
            <ng-container *ngFor="let file of files | categoriaAmministrazioneTrasparente: 'consulenze_collaborazioni'">                
                <a [href]="file.pdf | pdf" target="_blank" class="py-4 px-12 w-fit btn btn-sm btn-outln mt-4 block">{{file.titolo}}</a>
            </ng-container>
            <h4 class="font-mono lg:text-2xl text-xl mt-12">Contributi Pubblici</h4>
            <ng-container *ngFor="let file of files | categoriaAmministrazioneTrasparente: 'contributi_pubblici'">
                <a [href]="file.pdf | pdf" target="_blank" class="py-4 px-12 w-fit btn btn-sm btn-outln mt-4 block">{{file.titolo}}</a>
            </ng-container>
        </div>
    </div>
</section>